import React, { useEffect } from 'react';
import defaultStyles from 'commonStyles/components/coupon/_loyalty';
import { sendLoyaltyModalEvent, sendLoyaltyProgramEvent } from 'common/util/gtm-helper';
import styleOverrides from 'styles/components/coupon/_loyalty';
import useStyleOverrides from 'common/components/hooks/use-style-overrides';
import PropTypes from 'prop-types';

const LoyaltyCouponSuccess = ({
  loyaltyCta,
  successDisclaimer,
  handleButtonsClick,
}) => {
  const styles = useStyleOverrides(defaultStyles, styleOverrides);

  useEffect(() => {
    sendLoyaltyModalEvent('impression', 'success');
    sendLoyaltyProgramEvent('apply coupon 20', 'coupon 20 modal');
  }, []);

  const handleSuccessButton = () => {
    sendLoyaltyModalEvent('keep shopping click', 'success');
    handleButtonsClick();
  };

  return (<>
    <p className={styles.couponDescription}>
      {loyaltyCta.description}
    </p>
    {loyaltyCta.buttons.map(btn => (
      <a
        key={`loyaltyCouponSuccessCta-${btn.title}`}
        className={styles.successCtaLink}
        onClick={handleSuccessButton}
        href={btn.url}
      >
        {btn.title}
      </a>
    ))}
    <div className={styles.disclaimer}>
      <span>
        {successDisclaimer}
      </span>
    </div>
    </>
  );
};

LoyaltyCouponSuccess.propTypes = {
  loyaltyCta: PropTypes.shape({
    description: PropTypes.string.isRequired,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    ),
  }),
  successDisclaimer: PropTypes.string.isRequired,
  handleButtonsClick: PropTypes.func.isRequired,
};

export default LoyaltyCouponSuccess;
